import { use_slice_ui } from '@/hooks/store/use_slices';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useState } from 'react';
import { U_INPUT__user_task_name } from './U_INPUT__user_task_name';
import { U_LIST_ITEM__user_task } from './U_LIST_ITEM__user_task';

interface PROPS {
  user_task: DTO__user_task;
}

export function U_LIST_ITEM__user_task_master({ user_task }: PROPS) {
  const { page_tasks_new_task_id } = use_slice_ui(['page_tasks_new_task_id']);
  const [is_edit_name, set_is_edit_name] = useState(false);

  /*
   *
   */
  let out = <></>;
  if (is_edit_name || page_tasks_new_task_id === user_task._id) {
    out = <U_INPUT__user_task_name {...{ user_task, set_is_edit_name }} />;
  } else {
    out = <U_LIST_ITEM__user_task {...{ user_task, set_is_edit_name }} />;
  }

  return out;
}
